export const hasPerm = (user, perm) =>
  !!user && (user.role === "owner" || (user.role === "staff" && (user.permissions || []).includes(perm)));

export const SUB_STATUS = {
  available: { label: "Tersedia", cls: "text-[#35C78A] border-[#35C78A]" },
  paused: { label: "Dijeda", cls: "text-[#A8A8AD] border-[#35353B]" },
  recorded: { label: "Tercatat", cls: "text-[#5FC3F0] border-[#5FC3F0]" },
  pending: { label: "Tercatat", cls: "text-[#5FC3F0] border-[#5FC3F0]" },
  approved: { label: "Approved", cls: "text-[#35C78A] border-[#35C78A]" },
  rejected: { label: "Rejected", cls: "text-[#F06464] border-[#F06464]" },
};
